import { render, staticRenderFns } from "./FormContactBrain.vue?vue&type=template&id=4594c916&scoped=true"
import script from "./FormContactBrain.vue?vue&type=script&lang=js"
export * from "./FormContactBrain.vue?vue&type=script&lang=js"
import style0 from "./FormContactBrain.vue?vue&type=style&index=0&id=4594c916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4594c916",
  null
  
)

export default component.exports